import styled from 'styled-components';
export const Wrapper = styled.div `
  position: relative;
  ${({ isPieOrDonut, chartHeight }) => isPieOrDonut
    ? ''
    : `height: ${Number.isInteger(chartHeight) ? `${chartHeight}px` : chartHeight}`};
  ${({ isPieOrDonut, chartWidth }) => isPieOrDonut
    ? 'width: 100%'
    : `width: ${Number.isInteger(chartWidth) ? `${chartWidth}px` : chartWidth}`};
`;
